// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"338":"31d6cfe0","342":"d50e42de"}[chunkId] + ".chunk.css";
};